/* Henne mega menu (concept A "Columns"): behaviour for snippets/henne-mega-nav.liquid and snippets/henne-mega-drawer.liquid.
 *
 * Desktop (>= 1280px), <henne-mega-nav> + its panels (#HnMm-<section id>):
 *   hover intent (open after 150 ms, close 200 ms after the pointer leaves), click / Enter / Space toggle, Esc closes and
 *   returns focus to the button, one panel at a time, a click on the overlay or anywhere outside closes, Tab on an open
 *   button moves into its panel (and out of it again at both ends), closes below 1280px and when the nav row scrolls away,
 *   aria-expanded kept in sync, theme editor block selection opens the panel that holds the block.
 * SHOP BY BIKE: the saved bike (localStorage "henne_ymm_bike", written by the Harley finder) with its per-category counts
 *   from /collections/<bike>?view=mm-counts (fetched once, cached in sessionStorage), or Year / Family / Model selects built
 *   from henne-ymm-index.json the same way assets/henne-ymm-finder.js does (same storage format, same target page).
 * Phone drawer: accordions (one delegated click listener) and the "your bike" box.
 * No dependencies. Motion is CSS only and respects prefers-reduced-motion (assets/henne-megamenu.css). */
(function () {
  if (window.HenneMegaMenu) return;

  const BIKE_KEY = "henne_ymm_bike";
  const COUNTS_PREFIX = "henne_mm_counts:";
  const OPEN_DELAY = 150;
  const CLOSE_DELAY = 200;
  const DESKTOP_QUERY = "(min-width: 1280px)";
  const FOCUSABLE = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------------- saved bike, finder index, per-bike counts ---------------- */

  function readBike() {
    try {
      const raw = window.localStorage.getItem(BIKE_KEY);
      const bike = raw ? JSON.parse(raw) : null;
      return bike && bike.handle ? bike : null;
    } catch (e) {
      return null;
    }
  }

  function saveBike(bike) {
    try {
      if (bike) window.localStorage.setItem(BIKE_KEY, JSON.stringify(bike));
      else window.localStorage.removeItem(BIKE_KEY);
    } catch (e) {}
  }

  function collectionUrl(rootUrl, handle) {
    return (rootUrl || "/").replace(/\/?$/, "/") + "collections/" + encodeURIComponent(handle);
  }

  // "2021 Road Glide Special FLTRXS" until the bike collection title arrives with the counts.
  function bikeName(bike) {
    return ((bike.year ? bike.year + " " : "") + (bike.model || "")).trim();
  }

  const indexCache = {};
  function loadIndex(url) {
    if (!indexCache[url]) {
      indexCache[url] = fetch(url, { credentials: "same-origin" })
        .then((r) => {
          if (!r.ok) throw new Error("index " + r.status);
          return r.json();
        })
        .then((data) => {
          if (!data || !data.y || !data.years) throw new Error("index format");
          return data;
        })
        .catch((e) => {
          delete indexCache[url];
          throw e;
        });
    }
    return indexCache[url];
  }

  function peekCounts(handle) {
    try {
      const raw = window.sessionStorage.getItem(COUNTS_PREFIX + handle);
      const data = raw ? JSON.parse(raw) : null;
      return data && typeof data.count === "number" ? data : null;
    } catch (e) {
      return null;
    }
  }

  const countsCache = {};
  function loadCounts(rootUrl, handle) {
    if (countsCache[handle]) return countsCache[handle];
    const stored = peekCounts(handle);
    if (stored) {
      countsCache[handle] = Promise.resolve(stored);
      return countsCache[handle];
    }
    countsCache[handle] = fetch(collectionUrl(rootUrl, handle) + "?view=mm-counts", { credentials: "same-origin" })
      .then((r) => {
        if (!r.ok) throw new Error("counts " + r.status);
        return r.text();
      })
      .then((text) => {
        const data = JSON.parse(text);
        if (!data || typeof data.count !== "number") throw new Error("counts format");
        try {
          window.sessionStorage.setItem(COUNTS_PREFIX + handle, JSON.stringify(data));
        } catch (e) {}
        return data;
      })
      .catch((e) => {
        delete countsCache[handle];
        throw e;
      });
    return countsCache[handle];
  }

  function countLink(item) {
    const a = document.createElement("a");
    a.className = "hn-mm-link";
    a.href = item.url;
    a.append(document.createTextNode(item.label + " "));
    const n = document.createElement("span");
    n.className = "hn-mm-count";
    n.textContent = String(item.count);
    a.append(n);
    const li = document.createElement("li");
    li.append(a);
    return li;
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  /* ---------------- SHOP BY BIKE box (desktop panel) ---------------- */

  class BikeBox {
    constructor(root) {
      this.root = root;
      this.rootUrl = root.dataset.rootUrl || "/";
      this.indexUrl = root.dataset.indexUrl;
      this.saved = root.querySelector("[data-bike-saved]");
      this.nameEl = root.querySelector("[data-bike-name]");
      this.linkEl = root.querySelector("[data-bike-link]");
      this.countEl = root.querySelector("[data-bike-count]");
      this.changeBtn = root.querySelector("[data-bike-change]");
      this.split = root.querySelector("[data-bike-split]");
      this.cats = root.querySelector("[data-bike-cats]");
      this.form = root.querySelector("[data-bike-form]");
      this.fields = {
        year: root.querySelector('[data-field="year"]'),
        family: root.querySelector('[data-field="family"]'),
        model: root.querySelector('[data-field="model"]'),
      };
      this.submit = root.querySelector("[data-bike-submit]");
      this.keepBtn = root.querySelector("[data-bike-keep]");
      this.keepName = root.querySelector("[data-bike-keep-name]");
      this.status = root.querySelector("[data-bike-status]");
      this.index = null;
      this.bike = null;
      this.changing = false;
      this.ok = !!(this.saved && this.form && this.fields.year && this.fields.family && this.fields.model && this.submit);
      if (!this.ok) return;

      // Placeholder text = the first <option> rendered by Liquid (as in the finder).
      const placeholder = (select, fallback) => {
        const first = select.options && select.options[0];
        return first && first.value === "" && first.textContent.trim() ? first.textContent.trim() : fallback;
      };
      this.placeholders = {
        year: placeholder(this.fields.year, "Select Year"),
        family: placeholder(this.fields.family, "Select Family"),
        model: placeholder(this.fields.model, "Select Model"),
      };

      this.form.addEventListener("change", this.onChange);
      this.form.addEventListener("submit", this.onSubmit);
      if (this.changeBtn) {
        this.changeBtn.addEventListener("click", () => {
          this.changing = true;
          this.render();
          this.fields.year.focus();
        });
      }
      if (this.keepBtn) {
        this.keepBtn.addEventListener("click", () => {
          this.changing = false;
          this.render();
          if (this.changeBtn) this.changeBtn.focus();
        });
      }
      this.refresh();
    }

    // Re-read the saved bike (the finder bar on the page may have changed it) and show the right state.
    refresh() {
      if (!this.ok) return;
      this.bike = readBike();
      this.changing = false;
      this.render();
    }

    // Warm the data while the pointer rests on SHOP BY BIKE.
    prefetch() {
      if (!this.ok) return;
      const bike = readBike();
      if (bike) loadCounts(this.rootUrl, bike.handle).catch(() => {});
      else this.ensureIndex();
    }

    render() {
      const bike = this.bike;
      const showSaved = !!bike && !this.changing;
      this.saved.hidden = !showSaved;
      this.form.hidden = showSaved;
      if (showSaved) {
        this.showBike(bike);
        return;
      }
      if (this.keepBtn) {
        this.keepBtn.hidden = !bike;
        if (bike && this.keepName) this.keepName.textContent = bikeName(bike);
      }
      this.ensureIndex();
    }

    showBike(bike) {
      this.nameEl.textContent = bikeName(bike);
      this.linkEl.href = collectionUrl(this.rootUrl, bike.handle);
      this.countEl.textContent = "";
      this.cats.replaceChildren();
      this.split.hidden = true;
      loadCounts(this.rootUrl, bike.handle)
        .then((data) => {
          if (!this.bike || this.bike.handle !== bike.handle) return;
          if (data.title) this.nameEl.textContent = data.title;
          if (data.url) this.linkEl.href = data.url;
          this.countEl.textContent = data.count > 0 ? String(data.count) : "";
          const cats = (data.categories || [])
            .filter((c) => c && c.label && c.url && c.count > 0)
            .sort((a, b) => b.count - a.count);
          this.cats.replaceChildren(...cats.map(countLink));
          this.split.hidden = cats.length === 0;
        })
        .catch(() => {});
    }

    setStatus(text) {
      if (this.status) this.status.textContent = text || "";
    }

    ensureIndex() {
      if (this.index) {
        this.refreshSelects();
        return;
      }
      if (!this.indexUrl) return;
      loadIndex(this.indexUrl)
        .then((data) => {
          if (this.index) return;
          this.index = data;
          this.setStatus("");
          // Pre-select the saved bike, like the finder does.
          const bike = readBike();
          if (bike && data.y[bike.year] && data.y[bike.year][bike.family]) {
            this.fill(this.fields.year, this.placeholders.year, data.years);
            this.fields.year.value = String(bike.year);
            this.fill(this.fields.family, this.placeholders.family, this.families());
            this.fields.family.value = bike.family;
            this.fill(this.fields.model, this.placeholders.model, this.models().map((e) => e.m));
            this.fields.model.value = bike.model || "";
          }
          this.refreshSelects();
        })
        .catch(() => this.setStatus("Could not load motorcycles."));
    }

    // Same as the finder's fill(): keep the current value if still valid, auto-select a single option.
    fill(select, placeholder, values) {
      const current = select.value;
      select.replaceChildren();
      const empty = document.createElement("option");
      empty.value = "";
      empty.textContent = placeholder;
      select.append(empty);
      values.forEach((value) => {
        const option = document.createElement("option");
        option.value = String(value);
        option.textContent = String(value);
        select.append(option);
      });
      const keep = values.some((v) => String(v) === current);
      select.value = keep ? current : values.length === 1 ? String(values[0]) : "";
      select.disabled = values.length === 0;
    }

    yearData() {
      return this.index && this.fields.year.value ? this.index.y[this.fields.year.value] || null : null;
    }

    // Platform order from the index (Touring, Softail, Dyna, Sportster, V-Rod); unknown families last, A-Z.
    families() {
      const y = this.yearData();
      if (!y) return [];
      const order = this.index.families || [];
      const rank = (f) => {
        const i = order.indexOf(f);
        return i === -1 ? order.length : i;
      };
      return Object.keys(y).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
    }

    models() {
      const y = this.yearData();
      return y && this.fields.family.value ? y[this.fields.family.value] || [] : [];
    }

    selected() {
      const value = this.fields.model.value;
      return this.models().find((e) => e.m === value) || null;
    }

    refreshSelects() {
      if (!this.index) return;
      const f = this.fields;
      this.fill(f.year, this.placeholders.year, this.index.years);
      this.fill(f.family, this.placeholders.family, f.year.value ? this.families() : []);
      this.fill(f.model, this.placeholders.model, f.family.value ? this.models().map((e) => e.m) : []);
      this.submit.disabled = !this.selected();
    }

    onChange = (event) => {
      const field = event.target && event.target.dataset ? event.target.dataset.field : null;
      if (!field || !this.index) return;
      if (field === "year") {
        this.fields.family.value = "";
        this.fields.model.value = "";
      } else if (field === "family") {
        this.fields.model.value = "";
      }
      this.refreshSelects();
    };

    // Same target and storage as the finder in "open the bike's collection" mode.
    onSubmit = (event) => {
      event.preventDefault();
      const entry = this.selected();
      if (!entry) return;
      saveBike({ year: this.fields.year.value, family: this.fields.family.value, model: entry.m, handle: entry.h });
      window.location.href = collectionUrl(this.rootUrl, entry.h);
    };
  }

  /* ---------------- desktop nav row + panels ---------------- */

  class HenneMegaNav extends HTMLElement {
    connectedCallback() {
      // The panels are rendered later in the same section; wait a frame if they are not in the DOM yet.
      if (!this.setup()) window.requestAnimationFrame(() => this.isConnected && this.setup());
    }

    disconnectedCallback() {
      this.teardown();
    }

    setup() {
      if (this.panelsRoot) return true;
      const panelsRoot = document.getElementById(this.dataset.panelsId || "");
      if (!panelsRoot) return false;

      this.panelsRoot = panelsRoot;
      this.navBar = panelsRoot.closest(".m-header__nav") || panelsRoot.parentElement;
      this.overlay = panelsRoot.querySelector("[data-hn-mm-overlay]");
      this.toggles = Array.from(this.querySelectorAll("[data-hn-mm-toggle]"));
      this.mq = window.matchMedia(DESKTOP_QUERY);
      this.openKey = null;
      this.openedBy = null;
      this.openedAt = 0;
      this.openTimer = 0;
      this.closeTimer = 0;
      this.scrollFrame = 0;

      const bikeRoot = panelsRoot.querySelector("[data-hn-mm-bike]");
      this.bikeBox = bikeRoot ? new BikeBox(bikeRoot) : null;

      this.toggles.forEach((button) => {
        button.addEventListener("click", this.onToggleClick);
        button.addEventListener("keydown", this.onToggleKeydown);
        button.addEventListener("pointerenter", this.onTogglePointerEnter);
        button.addEventListener("pointerleave", this.onPointerLeave);
      });
      this.panels().forEach((panel) => {
        panel.addEventListener("pointerenter", this.onPanelPointerEnter);
        panel.addEventListener("pointerleave", this.onPointerLeave);
        panel.addEventListener("keydown", this.onPanelKeydown);
        panel.addEventListener("focusin", this.onPanelEngage);
        panel.addEventListener("pointerdown", this.onPanelEngage);
      });

      document.addEventListener("keydown", this.onDocumentKeydown);
      document.addEventListener("pointerdown", this.onDocumentPointerdown);
      document.addEventListener("mouseout", this.onDocumentMouseout);
      document.addEventListener("focusin", this.onDocumentFocusin);
      document.addEventListener("shopify:block:select", this.onBlockSelect);
      document.addEventListener("shopify:block:deselect", this.onBlockDeselect);
      window.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onResize);
      if (this.mq.addEventListener) this.mq.addEventListener("change", this.onMediaChange);
      else if (this.mq.addListener) this.mq.addListener(this.onMediaChange);
      return true;
    }

    teardown() {
      if (!this.panelsRoot) return;
      this.close();
      document.removeEventListener("keydown", this.onDocumentKeydown);
      document.removeEventListener("pointerdown", this.onDocumentPointerdown);
      document.removeEventListener("mouseout", this.onDocumentMouseout);
      document.removeEventListener("focusin", this.onDocumentFocusin);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
      document.removeEventListener("shopify:block:deselect", this.onBlockDeselect);
      window.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onResize);
      if (this.mq.removeEventListener) this.mq.removeEventListener("change", this.onMediaChange);
      else if (this.mq.removeListener) this.mq.removeListener(this.onMediaChange);
      this.panelsRoot = null;
    }

    panels() {
      return this.toggles.map((button) => this.panelFor(button)).filter(Boolean);
    }

    panelFor(button) {
      return button ? document.getElementById(button.getAttribute("aria-controls")) : null;
    }

    toggleFor(key) {
      return this.toggles.find((button) => button.dataset.hnMmToggle === key) || null;
    }

    focusables(container) {
      return Array.from(container.querySelectorAll(FOCUSABLE)).filter(isVisible);
    }

    // Panel top = bottom of the nav row; the overlay starts there, the panel scrolls inside the viewport if needed.
    updateGeometry() {
      const top = Math.max(0, Math.round(this.navBar.getBoundingClientRect().bottom));
      this.panelsRoot.style.setProperty("--hn-mm-top", top + "px");
      this.panelsRoot.style.setProperty("--hn-mm-max-h", Math.max(200, window.innerHeight - top) + "px");
    }

    open(key, by) {
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.closeTimer);
      if (!this.mq.matches) return;
      const button = this.toggleFor(key);
      const panel = this.panelFor(button);
      if (!panel) return;
      if (this.openKey && this.openKey !== key) this.hide(this.openKey);
      this.updateGeometry();
      button.setAttribute("aria-expanded", "true");
      panel.classList.add("is-open");
      if (this.overlay) this.overlay.classList.add("is-open");
      if (this.openKey !== key) this.openedAt = Date.now();
      this.openKey = key;
      this.openedBy = by;
      if (key === "bike" && this.bikeBox) this.bikeBox.refresh();
    }

    hide(key) {
      const button = this.toggleFor(key);
      const panel = this.panelFor(button);
      if (button) button.setAttribute("aria-expanded", "false");
      if (panel) panel.classList.remove("is-open");
    }

    close(returnFocus) {
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.closeTimer);
      if (!this.openKey) return;
      const button = this.toggleFor(this.openKey);
      this.hide(this.openKey);
      if (this.overlay) this.overlay.classList.remove("is-open");
      this.openKey = null;
      this.openedBy = null;
      if (returnFocus && button) button.focus();
    }

    scheduleClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.close(), CLOSE_DELAY);
    }

    owns(node) {
      return !!node && (this.contains(node) || (this.panelsRoot && this.panelsRoot.contains(node) && node !== this.overlay));
    }

    /* ----- pointer ----- */

    onTogglePointerEnter = (event) => {
      if (event.pointerType !== "mouse") return;
      const key = event.currentTarget.dataset.hnMmToggle;
      window.clearTimeout(this.closeTimer);
      if (key === "bike" && this.bikeBox) this.bikeBox.prefetch();
      if (this.openKey === key) return;
      if (this.openKey) {
        this.open(key, this.openedBy); // another panel is open: switch at once
        return;
      }
      window.clearTimeout(this.openTimer);
      this.openTimer = window.setTimeout(() => this.open(key, "hover"), OPEN_DELAY);
    };

    onPanelPointerEnter = (event) => {
      if (event.pointerType !== "mouse" || !event.currentTarget.classList.contains("is-open")) return;
      window.clearTimeout(this.closeTimer);
    };

    // The pointer left the page or went into an iframe (chat widget, preview bar): no pointerleave reaches us then.
    onDocumentMouseout = (event) => {
      if (!event.relatedTarget && this.openKey && this.openedBy === "hover") this.scheduleClose();
    };

    onPointerLeave = (event) => {
      if (event.pointerType !== "mouse") return;
      window.clearTimeout(this.openTimer);
      if (this.openKey && this.openedBy === "hover") this.scheduleClose();
    };

    // Once the shopper clicks or tabs inside a hover-opened panel it stays open until Esc / outside click.
    onPanelEngage = () => {
      if (this.openedBy === "hover") this.openedBy = "pinned";
      window.clearTimeout(this.closeTimer);
    };

    onToggleClick = (event) => {
      const key = event.currentTarget.dataset.hnMmToggle;
      window.clearTimeout(this.openTimer);
      if (this.openKey !== key) {
        this.open(key, "click");
        return;
      }
      // A click right after hover opened the panel keeps it open (and pins it) instead of closing it again.
      if (this.openedBy === "hover" && Date.now() - this.openedAt < 600) {
        this.openedBy = "click";
        return;
      }
      this.close();
    };

    onDocumentPointerdown = (event) => {
      if (this.openKey && !this.owns(event.target)) this.close();
    };

    /* ----- keyboard ----- */

    onToggleKeydown = (event) => {
      const button = event.currentTarget;
      const key = button.dataset.hnMmToggle;
      if (event.key === "ArrowDown" || (event.key === "Tab" && !event.shiftKey && this.openKey === key)) {
        if (this.openKey !== key) this.open(key, "click");
        const first = this.focusables(this.panelFor(button))[0];
        if (first) {
          event.preventDefault();
          if (this.openedBy === "hover") this.openedBy = "pinned";
          first.focus();
        }
      }
    };

    onPanelKeydown = (event) => {
      if (event.key !== "Tab" || !this.openKey) return;
      const button = this.toggleFor(this.openKey);
      const items = this.focusables(event.currentTarget);
      if (!items.length) return;
      if (event.shiftKey && event.target === items[0]) {
        event.preventDefault();
        button.focus();
      } else if (!event.shiftKey && event.target === items[items.length - 1]) {
        // Leaving the end of the panel: close it and continue with the item after its button in the header.
        const scope = this.closest(".m-header__menu") || this;
        const row = this.focusables(scope);
        const next = row[row.indexOf(button) + 1];
        event.preventDefault();
        this.close();
        (next || button).focus();
      }
    };

    onDocumentKeydown = (event) => {
      if (event.key !== "Escape" || !this.openKey) return;
      const active = document.activeElement;
      const focusInMenu = !active || active === document.body || this.owns(active);
      this.close(focusInMenu);
    };

    onDocumentFocusin = (event) => {
      if (this.openKey && !this.owns(event.target)) this.close();
    };

    /* ----- viewport ----- */

    onScroll = () => {
      if (!this.openKey || this.scrollFrame) return;
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = 0;
        if (!this.openKey) return;
        // Keep the panel only while the nav row is on screen (sticky header revealed, or not scrolled past yet).
        const hidden = this.navBar.classList.contains("nav-bar-hidden") || this.navBar.getBoundingClientRect().bottom <= 0;
        if (hidden) this.close();
        else this.updateGeometry();
      });
    };

    onResize = () => {
      if (!this.openKey) return;
      if (!this.mq.matches) this.close();
      else this.updateGeometry();
    };

    onMediaChange = () => {
      if (!this.mq.matches) this.close();
    };

    /* ----- theme editor: selecting a block opens its panel ----- */

    onBlockSelect = (event) => {
      const panel = event.target && event.target.closest ? event.target.closest("[data-hn-mm-panel]") : null;
      if (panel && this.panelsRoot && this.panelsRoot.contains(panel)) this.open(panel.dataset.hnMmPanel, "editor");
    };

    onBlockDeselect = () => {
      if (this.openedBy === "editor") this.close();
    };
  }

  if (!window.customElements.get("henne-mega-nav")) window.customElements.define("henne-mega-nav", HenneMegaNav);

  /* ---------------- phone drawer ---------------- */

  function setDrawerItem(button, open) {
    button.setAttribute("aria-expanded", open ? "true" : "false");
    const panel = document.getElementById(button.getAttribute("aria-controls"));
    if (panel) panel.hidden = !open;
  }

  function fillDrawerBike(box, allowFetch) {
    const bike = readBike();
    if (!bike) {
      box.hidden = true;
      return;
    }
    const rootUrl = box.dataset.rootUrl || "/";
    const name = box.querySelector("[data-bike-name]");
    const link = box.querySelector("[data-bike-link]");
    const count = box.querySelector("[data-bike-count]");
    const apply = (data) => {
      if (!data || data.handle !== bike.handle) return;
      if (name && data.title) name.textContent = data.title;
      if (link && data.url) link.href = data.url;
      if (count) count.textContent = data.count > 0 ? String(data.count) : "";
    };
    if (name) name.textContent = bikeName(bike);
    if (link) link.href = collectionUrl(rootUrl, bike.handle);
    if (count) count.textContent = "";
    box.hidden = false;
    const cached = peekCounts(bike.handle);
    if (cached) apply(cached);
    else if (allowFetch) loadCounts(rootUrl, bike.handle).then(apply).catch(() => {});
  }

  function onDrawerClick(event) {
    const button = event.target && event.target.closest ? event.target.closest("[data-hn-mmd-toggle]") : null;
    if (!button) return;
    const open = button.getAttribute("aria-expanded") !== "true";
    const group = button.getAttribute("data-hn-mmd-group");
    if (open && group) {
      // Categories: one open at a time.
      document.querySelectorAll('[data-hn-mmd-group="' + group + '"][aria-expanded="true"]').forEach((other) => {
        if (other !== button) setDrawerItem(other, false);
      });
    }
    setDrawerItem(button, open);
    if (open && button.dataset.hnMmdToggle === "bike") {
      const panel = document.getElementById(button.getAttribute("aria-controls"));
      const box = panel && panel.querySelector("[data-hn-mmd-bike]");
      if (box) fillDrawerBike(box, true);
    }
  }

  function initDrawers(scope) {
    (scope || document).querySelectorAll("[data-hn-mmd-bike]").forEach((box) => fillDrawerBike(box, false));
  }

  document.addEventListener("click", onDrawerClick);
  document.addEventListener("shopify:section:load", (event) => initDrawers(event.target));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initDrawers());
  else initDrawers();

  window.HenneMegaMenu = { readBike: readBike, loadCounts: loadCounts };
})();
